import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaMicrophone } from 'react-icons/fa';
import './ProductsTeaser.css';

const ProductsTeaser = () => {
  const [ref, inView] = useInView({ threshold: 0.15, triggerOnce: true });

  return (
    <section className="pt-section">
      <Container>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          {/* Section label */}
          <div className="text-center mb-5">
            <h6 className="text-gradient fw-bold mb-2">OUR PRODUCTS</h6>
            <h2 className="fw-bold display-5 mb-3">Beyond Consulting, We Build AI Software</h2>
            <p className="lead mx-auto" style={{ maxWidth: '640px', color: '#555' }}>
              SPIRENEST TECHNOLOGIES builds practical AI software products that help
              individuals and teams work faster.
            </p>
          </div>

          {/* Product card */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="pt-card">
                <Row className="align-items-center g-4">
                  <Col md={2} className="text-center">
                    <div className="pt-product-icon">
                      <FaMicrophone />
                    </div>
                  </Col>
                  <Col md={7}>
                    <div className="pt-badge mb-2">AI Software Product</div>
                    <h3 className="pt-product-name">ThinkingHub Assist</h3>
                    <p className="pt-product-tagline">
                      AI voice dictation and voice assistant for Windows and macOS
                    </p>
                    <div className="pt-features-row">
                      {[
                        'Real-time voice-to-text',
                        'Voice commands',
                        'Works in all apps',
                        'Privacy-first',
                      ].map((f) => (
                        <span key={f} className="pt-feature-chip">{f}</span>
                      ))}
                    </div>
                  </Col>
                  <Col md={3} className="text-md-end text-center">
                    <Link to="/products" className="pt-cta-btn">
                      See all products <FaArrowRight className="pt-cta-arr" />
                    </Link>
                    <p className="pt-coming-soon mt-2">Coming Soon</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          {/* Link row */}
          <div className="text-center mt-4">
            <Link to="/products" className="pt-see-all">
              See all products <FaArrowRight style={{ fontSize: '0.8rem' }} />
            </Link>
          </div>
        </motion.div>
      </Container>
    </section>
  );
};

export default ProductsTeaser;
